import { BrowserRouter, Navigate, Route, Routes } from 'react-router'
import { RequireOAuthParams } from './components/RequireOAuthParams'
import { AuthorizePage } from './pages/AuthorizePage'
import { ConsentPage } from './pages/ConsentPage'
import { LoginPage } from './pages/LoginPage'
import { RegisterPage } from './pages/RegisterPage'
import { ErrorBoundary } from './providers/ErrorBoundary'
import { OAuthProvider } from './providers/OAuthProvider'

export function App() {
	return (
		<ErrorBoundary>
			<OAuthProvider>
				<BrowserRouter>
					<Routes>
						<Route path="/authorize" element={<AuthorizePage />} />
						<Route path="/login" element={
							<RequireOAuthParams><LoginPage /></RequireOAuthParams>
						} />
						<Route path="/register" element={
							<RequireOAuthParams><RegisterPage /></RequireOAuthParams>
						} />
						<Route path="/consent" element={
							<RequireOAuthParams><ConsentPage /></RequireOAuthParams>
						} />
						<Route path="*" element={<Navigate to="/authorize" replace />} />
					</Routes>
				</BrowserRouter>
			</OAuthProvider>
		</ErrorBoundary>
	)
}
